"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeScheduledCacheCleanup = exports.isScheduledCacheCleanup = exports.isLocalStorageAvailable = exports.getStorage = void 0;
var _constants = require("../constants");
var _logger = require("../logger");
const getStorage = () => typeof window === 'object' && window.localStorage;

/** Returns true if the local storage is available. */
exports.getStorage = getStorage;
const isLocalStorageAvailable = () => {
  const isAvailable = Boolean(getStorage());
  if (!isAvailable) {
    (0, _logger.logWarning)('Storage is not available.');
  }
  return isAvailable;
};

/**
 * Checks for scheduled cache cleanup flag presence in storage.
 * This is small data and optionally being also set in legacy Online,
 * so always using localStorage in current implementation.
 */
exports.isLocalStorageAvailable = isLocalStorageAvailable;
const isScheduledCacheCleanup = () => {
  if (!isLocalStorageAvailable()) {
    return false;
  }
  const result = localStorage.getItem(_constants.SCHEDULED_CLEANUP_KEY);
  if (result) {
    (0, _logger.logDebug)('Cache cleanup was scheduled with last page reload.');
  }
  return result === null ? false : Boolean(result);
};

/** Removes scheduled cache cleanup flag from storage. */
exports.isScheduledCacheCleanup = isScheduledCacheCleanup;
const removeScheduledCacheCleanup = () => {
  if (!isLocalStorageAvailable()) {
    return false;
  }
  localStorage.removeItem(_constants.SCHEDULED_CLEANUP_KEY);
  return true;
};
exports.removeScheduledCacheCleanup = removeScheduledCacheCleanup;